export default __webpack_public_path__ + "static/media/ciclovias.b03d0f27.svg";